/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BatchCreateCommitmentsRequest } from '../models';
// @ts-ignore
import type { BatchCreateCommitmentsResponse } from '../models';
// @ts-ignore
import type { BatchDeleteCommitmentsRequest } from '../models';
// @ts-ignore
import type { BatchGetCommitmentUsageBreakdownsResponse } from '../models';
// @ts-ignore
import type { Commitment } from '../models';
// @ts-ignore
import type { CommitmentUsageBreakdown } from '../models';
// @ts-ignore
import type { CreateCommitmentInput } from '../models';
// @ts-ignore
import type { GetAzureReservationsImportCommandResponse } from '../models';
// @ts-ignore
import type { GetCommitmentAssignedClustersResponse } from '../models';
// @ts-ignore
import type { ListCommitmentAssignmentsResponse } from '../models';
// @ts-ignore
import type { ListCommitmentsResponse } from '../models';
// @ts-ignore
import type { Status } from '../models';
// @ts-ignore
import type { UpdateCommitmentInput } from '../models';
// @ts-ignore
import type { UsageSummary } from '../models';
/**
 * CommitmentsAPIApi - axios parameter creator
 * @export
 */
export const CommitmentsAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Batch create commitments. A maximum of 1000 commitments can be created in a single batch.  The operation is atomic: all commitments are created or none are.
         * @summary Batch create commitments.
         * @param {string} organizationId Organization ID shared by all commitments
         * @param {BatchCreateCommitmentsRequest} batchCreateCommitmentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitmentsAPIBatchCreateCommitments: async (organizationId: string, batchCreateCommitmentsRequest: BatchCreateCommitmentsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('commitmentsAPIBatchCreateCommitments', 'organizationId', organizationId)
            // verify required parameter 'batchCreateCommitmentsRequest' is not null or undefined
            assertParamExists('commitmentsAPIBatchCreateCommitments', 'batchCreateCommitmentsRequest', batchCreateCommitmentsRequest)
            const localVarPath = `/pricing/v1beta/organizations/{organizationId}/commitments:batchCreate`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchCreateCommitmentsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Batch delete commitments. A maximum of 1000 commitments can be deleted in a single batch.  The operation is atomic: all commitments are deleted or none are.
         * @summary Batch delete commitments.
         * @param {string} organizationId Organization ID shared by all commitments
         * @param {BatchDeleteCommitmentsRequest} batchDeleteCommitmentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitmentsAPIBatchDeleteCommitments: async (organizationId: string, batchDeleteCommitmentsRequest: BatchDeleteCommitmentsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('commitmentsAPIBatchDeleteCommitments', 'organizationId', organizationId)
            // verify required parameter 'batchDeleteCommitmentsRequest' is not null or undefined
            assertParamExists('commitmentsAPIBatchDeleteCommitments', 'batchDeleteCommitmentsRequest', batchDeleteCommitmentsRequest)
            const localVarPath = `/pricing/v1beta/organizations/{organizationId}/commitments:batchDelete`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchDeleteCommitmentsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Batch get usage breakdowns for multiple commitments.  Intended for table views where per-commitment usage data is needed for each row.  Returns breakdowns in the same order as the requested ids.
         * @summary Batch get commitment usage breakdowns.
         * @param {string} organizationId Organization ID
         * @param {Array<string>} [ids] Commitment IDs to fetch breakdowns for. A maximum of 1000 commitments can be retrieved in a batch.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitmentsAPIBatchGetCommitmentUsageBreakdowns: async (organizationId: string, ids?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('commitmentsAPIBatchGetCommitmentUsageBreakdowns', 'organizationId', organizationId)
            const localVarPath = `/pricing/v1beta/organizations/{organizationId}/commitments/-/usage-breakdown:batchGet`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new commitment
         * @summary Create a commitment.
         * @param {string} organizationId Organization ID
         * @param {CreateCommitmentInput} createCommitmentInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitmentsAPICreateCommitment: async (organizationId: string, createCommitmentInput: CreateCommitmentInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('commitmentsAPICreateCommitment', 'organizationId', organizationId)
            // verify required parameter 'createCommitmentInput' is not null or undefined
            assertParamExists('commitmentsAPICreateCommitment', 'createCommitmentInput', createCommitmentInput)
            const localVarPath = `/pricing/v1beta/organizations/{organizationId}/commitments`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCommitmentInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a commitment by ID.
         * @summary Delete a commitment.
         * @param {string} organizationId Organization ID
         * @param {string} id ID of the commitment to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitmentsAPIDeleteCommitment: async (organizationId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('commitmentsAPIDeleteCommitment', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('commitmentsAPIDeleteCommitment', 'id', id)
            const localVarPath = `/pricing/v1beta/organizations/{organizationId}/commitments/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Azure commitments (reservations) import command
         * @param {string} organizationId Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitmentsAPIGetAzureReservationsImportCommand: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('commitmentsAPIGetAzureReservationsImportCommand', 'organizationId', organizationId)
            const localVarPath = `/pricing/v1beta/organizations/{organizationId}/commitments:getAzureReservationsImportCommand`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a Azure commitments (reservations) import script
         * @param {string} organizationId Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitmentsAPIGetAzureReservationsImportScript: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('commitmentsAPIGetAzureReservationsImportScript', 'organizationId', organizationId)
            const localVarPath = `/pricing/v1beta/organizations/{organizationId}/commitments:getAzureReservationsImportScript`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single commitment by ID.
         * @summary Get a commitment.
         * @param {string} organizationId Organization ID
         * @param {string} id ID of the commitment to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitmentsAPIGetCommitment: async (organizationId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('commitmentsAPIGetCommitment', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('commitmentsAPIGetCommitment', 'id', id)
            const localVarPath = `/pricing/v1beta/organizations/{organizationId}/commitments/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * (-- api-linter: core::0131::response-message-name=disabled      aip.dev/not-precedent: Custom method returning a custom response type. --)  Get clusters that have assignments for all of the given commitments in the  requested CSP.  At least one commitment_id is required; up to 100 per request.
         * @summary Get clusters assigned to the given commitments.
         * @param {string} organizationId Organization ID
         * @param {Array<string>} [commitmentIds] Filter to clusters assigned to ALL of these commitment IDs.  A cluster is returned only if it has an assignment for every commitment_id  in this list.  Required: at least one commitment_id; at most 100.
         * @param {CommitmentsAPIGetCommitmentAssignedClustersCloudEnum} [cloud] Required: filter by cloud service provider.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitmentsAPIGetCommitmentAssignedClusters: async (organizationId: string, commitmentIds?: Array<string>, cloud?: CommitmentsAPIGetCommitmentAssignedClustersCloudEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('commitmentsAPIGetCommitmentAssignedClusters', 'organizationId', organizationId)
            const localVarPath = `/pricing/v1beta/organizations/{organizationId}/commitments:getCommitmentAssignedClusters`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (commitmentIds) {
                localVarQueryParameter['commitmentIds'] = commitmentIds;
            }

            if (cloud !== undefined) {
                localVarQueryParameter['cloud'] = cloud;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get usage breakdown for a single commitment.  Returns per-instance-type and per-cluster usage data.  For fetching breakdowns for multiple commitments (e.g. a table view), use BatchGetCommitmentUsageBreakdowns.
         * @summary Get commitment usage breakdown.
         * @param {string} organizationId Organization ID
         * @param {string} commitmentId Commitment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitmentsAPIGetCommitmentUsageBreakdown: async (organizationId: string, commitmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('commitmentsAPIGetCommitmentUsageBreakdown', 'organizationId', organizationId)
            // verify required parameter 'commitmentId' is not null or undefined
            assertParamExists('commitmentsAPIGetCommitmentUsageBreakdown', 'commitmentId', commitmentId)
            const localVarPath = `/pricing/v1beta/organizations/{organizationId}/commitments/{commitmentId}/usage-breakdown`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"commitmentId"}}`, encodeURIComponent(String(commitmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get commitment usage summary split by Cast-managed and other clusters
         * @param {string} organizationId Organization ID
         * @param {string} commitmentId Commitment ID to filter by. Use \&quot;-\&quot; for all commitments.
         * @param {CommitmentsAPIGetUsageSummaryCloudEnum} [cloud] Filter by cloud provider
         * @param {CommitmentsAPIGetUsageSummaryCommitmentTypeEnum} [commitmentType] Filter by commitment type  Deprecated: Use commitment types instead
         * @param {Array<CommitmentsAPIGetUsageSummaryCommitmentTypesEnum>} [commitmentTypes] Filter by commitment types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitmentsAPIGetUsageSummary: async (organizationId: string, commitmentId: string, cloud?: CommitmentsAPIGetUsageSummaryCloudEnum, commitmentType?: CommitmentsAPIGetUsageSummaryCommitmentTypeEnum, commitmentTypes?: Array<CommitmentsAPIGetUsageSummaryCommitmentTypesEnum>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('commitmentsAPIGetUsageSummary', 'organizationId', organizationId)
            // verify required parameter 'commitmentId' is not null or undefined
            assertParamExists('commitmentsAPIGetUsageSummary', 'commitmentId', commitmentId)
            const localVarPath = `/pricing/v1beta/organizations/{organizationId}/commitments/{commitmentId}/usage-summary`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"commitmentId"}}`, encodeURIComponent(String(commitmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (cloud !== undefined) {
                localVarQueryParameter['cloud'] = cloud;
            }

            if (commitmentType !== undefined) {
                localVarQueryParameter['commitmentType'] = commitmentType;
            }

            if (commitmentTypes) {
                localVarQueryParameter['commitmentTypes'] = commitmentTypes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Import Azure commitments (reservations)
         * @param {string} organizationId Organization ID
         * @param {object} body 
         * @param {CommitmentsAPIImportAzureReservationsModeEnum} [mode] Behaviour
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitmentsAPIImportAzureReservations: async (organizationId: string, body: object, mode?: CommitmentsAPIImportAzureReservationsModeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('commitmentsAPIImportAzureReservations', 'organizationId', organizationId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('commitmentsAPIImportAzureReservations', 'body', body)
            const localVarPath = `/pricing/v1beta/organizations/{organizationId}/commitments:importAzureReservations`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (mode !== undefined) {
                localVarQueryParameter['mode'] = mode;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List commitment assignments with pagination support.  This endpoint follows AIP standards and supports pagination with a maximum of 10,000 items per page.
         * @summary List commitment assignments.
         * @param {string} organizationId Organization ID
         * @param {string} commitmentId Optional commitment ID to filter assignments by  Accepts: empty (gRPC), \&quot;-\&quot; (wildcard for REST API, treated as empty), or valid UUID
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitmentsAPIListCommitmentAssignments: async (organizationId: string, commitmentId: string, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('commitmentsAPIListCommitmentAssignments', 'organizationId', organizationId)
            // verify required parameter 'commitmentId' is not null or undefined
            assertParamExists('commitmentsAPIListCommitmentAssignments', 'commitmentId', commitmentId)
            const localVarPath = `/pricing/v1beta/organizations/{organizationId}/commitments/{commitmentId}/assignments`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"commitmentId"}}`, encodeURIComponent(String(commitmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List commitments with pagination, filtering, and sorting support.  Supersedes GetCommitments from the inventory API.
         * @summary List commitments.
         * @param {string} organizationId Organization ID
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {string} [sortField] The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
         * @param {CommitmentsAPIListCommitmentsSortOrderEnum} [sortOrder] The order of returned items. Default is ASC.
         * @param {Array<CommitmentsAPIListCommitmentsTypesEnum>} [types] Filter by commitment types
         * @param {Array<CommitmentsAPIListCommitmentsCloudsEnum>} [clouds] Filter by cloud providers
         * @param {string} [name] Filter by commitment name (case-insensitive, partial matching)
         * @param {Array<string>} [regions] Filter by regions
         * @param {string} [clusterId] Filter to commitments assigned to a specific cluster
         * @param {Array<CommitmentsAPIListCommitmentsStatesEnum>} [states] Filter by lifecycle states
         * @param {boolean} [includeTotalCount] Include total count of matching commitments in the response
         * @param {boolean} [unassigned] Filter to commitments that have no clusters assigned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitmentsAPIListCommitments: async (organizationId: string, pageLimit?: string, pageCursor?: string, sortField?: string, sortOrder?: CommitmentsAPIListCommitmentsSortOrderEnum, types?: Array<CommitmentsAPIListCommitmentsTypesEnum>, clouds?: Array<CommitmentsAPIListCommitmentsCloudsEnum>, name?: string, regions?: Array<string>, clusterId?: string, states?: Array<CommitmentsAPIListCommitmentsStatesEnum>, includeTotalCount?: boolean, unassigned?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('commitmentsAPIListCommitments', 'organizationId', organizationId)
            const localVarPath = `/pricing/v1beta/organizations/{organizationId}/commitments`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (sortField !== undefined) {
                localVarQueryParameter['sort.field'] = sortField;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort.order'] = sortOrder;
            }

            if (types) {
                localVarQueryParameter['types'] = types;
            }

            if (clouds) {
                localVarQueryParameter['clouds'] = clouds;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (regions) {
                localVarQueryParameter['regions'] = regions;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (states) {
                localVarQueryParameter['states'] = states;
            }

            if (includeTotalCount !== undefined) {
                localVarQueryParameter['includeTotalCount'] = includeTotalCount;
            }

            if (unassigned !== undefined) {
                localVarQueryParameter['unassigned'] = unassigned;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update mutable settings of an existing commitment.  Only operational settings (e.g. allowed usage, scaling strategy) are mutable via this method.
         * @summary Update a commitment.
         * @param {string} organizationId Organization ID
         * @param {string} id ID of the commitment to update
         * @param {UpdateCommitmentInput} updateCommitmentInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitmentsAPIUpdateCommitment: async (organizationId: string, id: string, updateCommitmentInput: UpdateCommitmentInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('commitmentsAPIUpdateCommitment', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('commitmentsAPIUpdateCommitment', 'id', id)
            // verify required parameter 'updateCommitmentInput' is not null or undefined
            assertParamExists('commitmentsAPIUpdateCommitment', 'updateCommitmentInput', updateCommitmentInput)
            const localVarPath = `/pricing/v1beta/organizations/{organizationId}/commitments/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCommitmentInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommitmentsAPIApi - functional programming interface
 * @export
 */
export const CommitmentsAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommitmentsAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Batch create commitments. A maximum of 1000 commitments can be created in a single batch.  The operation is atomic: all commitments are created or none are.
         * @summary Batch create commitments.
         * @param {string} organizationId Organization ID shared by all commitments
         * @param {BatchCreateCommitmentsRequest} batchCreateCommitmentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commitmentsAPIBatchCreateCommitments(organizationId: string, batchCreateCommitmentsRequest: BatchCreateCommitmentsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BatchCreateCommitmentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commitmentsAPIBatchCreateCommitments(organizationId, batchCreateCommitmentsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommitmentsAPIApi.commitmentsAPIBatchCreateCommitments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Batch delete commitments. A maximum of 1000 commitments can be deleted in a single batch.  The operation is atomic: all commitments are deleted or none are.
         * @summary Batch delete commitments.
         * @param {string} organizationId Organization ID shared by all commitments
         * @param {BatchDeleteCommitmentsRequest} batchDeleteCommitmentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commitmentsAPIBatchDeleteCommitments(organizationId: string, batchDeleteCommitmentsRequest: BatchDeleteCommitmentsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commitmentsAPIBatchDeleteCommitments(organizationId, batchDeleteCommitmentsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommitmentsAPIApi.commitmentsAPIBatchDeleteCommitments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Batch get usage breakdowns for multiple commitments.  Intended for table views where per-commitment usage data is needed for each row.  Returns breakdowns in the same order as the requested ids.
         * @summary Batch get commitment usage breakdowns.
         * @param {string} organizationId Organization ID
         * @param {Array<string>} [ids] Commitment IDs to fetch breakdowns for. A maximum of 1000 commitments can be retrieved in a batch.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commitmentsAPIBatchGetCommitmentUsageBreakdowns(organizationId: string, ids?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BatchGetCommitmentUsageBreakdownsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commitmentsAPIBatchGetCommitmentUsageBreakdowns(organizationId, ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommitmentsAPIApi.commitmentsAPIBatchGetCommitmentUsageBreakdowns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new commitment
         * @summary Create a commitment.
         * @param {string} organizationId Organization ID
         * @param {CreateCommitmentInput} createCommitmentInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commitmentsAPICreateCommitment(organizationId: string, createCommitmentInput: CreateCommitmentInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Commitment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commitmentsAPICreateCommitment(organizationId, createCommitmentInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommitmentsAPIApi.commitmentsAPICreateCommitment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a commitment by ID.
         * @summary Delete a commitment.
         * @param {string} organizationId Organization ID
         * @param {string} id ID of the commitment to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commitmentsAPIDeleteCommitment(organizationId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commitmentsAPIDeleteCommitment(organizationId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommitmentsAPIApi.commitmentsAPIDeleteCommitment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Azure commitments (reservations) import command
         * @param {string} organizationId Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commitmentsAPIGetAzureReservationsImportCommand(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAzureReservationsImportCommandResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commitmentsAPIGetAzureReservationsImportCommand(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommitmentsAPIApi.commitmentsAPIGetAzureReservationsImportCommand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a Azure commitments (reservations) import script
         * @param {string} organizationId Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commitmentsAPIGetAzureReservationsImportScript(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commitmentsAPIGetAzureReservationsImportScript(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommitmentsAPIApi.commitmentsAPIGetAzureReservationsImportScript']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single commitment by ID.
         * @summary Get a commitment.
         * @param {string} organizationId Organization ID
         * @param {string} id ID of the commitment to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commitmentsAPIGetCommitment(organizationId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Commitment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commitmentsAPIGetCommitment(organizationId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommitmentsAPIApi.commitmentsAPIGetCommitment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * (-- api-linter: core::0131::response-message-name=disabled      aip.dev/not-precedent: Custom method returning a custom response type. --)  Get clusters that have assignments for all of the given commitments in the  requested CSP.  At least one commitment_id is required; up to 100 per request.
         * @summary Get clusters assigned to the given commitments.
         * @param {string} organizationId Organization ID
         * @param {Array<string>} [commitmentIds] Filter to clusters assigned to ALL of these commitment IDs.  A cluster is returned only if it has an assignment for every commitment_id  in this list.  Required: at least one commitment_id; at most 100.
         * @param {CommitmentsAPIGetCommitmentAssignedClustersCloudEnum} [cloud] Required: filter by cloud service provider.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commitmentsAPIGetCommitmentAssignedClusters(organizationId: string, commitmentIds?: Array<string>, cloud?: CommitmentsAPIGetCommitmentAssignedClustersCloudEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCommitmentAssignedClustersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commitmentsAPIGetCommitmentAssignedClusters(organizationId, commitmentIds, cloud, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommitmentsAPIApi.commitmentsAPIGetCommitmentAssignedClusters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get usage breakdown for a single commitment.  Returns per-instance-type and per-cluster usage data.  For fetching breakdowns for multiple commitments (e.g. a table view), use BatchGetCommitmentUsageBreakdowns.
         * @summary Get commitment usage breakdown.
         * @param {string} organizationId Organization ID
         * @param {string} commitmentId Commitment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commitmentsAPIGetCommitmentUsageBreakdown(organizationId: string, commitmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommitmentUsageBreakdown>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commitmentsAPIGetCommitmentUsageBreakdown(organizationId, commitmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommitmentsAPIApi.commitmentsAPIGetCommitmentUsageBreakdown']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get commitment usage summary split by Cast-managed and other clusters
         * @param {string} organizationId Organization ID
         * @param {string} commitmentId Commitment ID to filter by. Use \&quot;-\&quot; for all commitments.
         * @param {CommitmentsAPIGetUsageSummaryCloudEnum} [cloud] Filter by cloud provider
         * @param {CommitmentsAPIGetUsageSummaryCommitmentTypeEnum} [commitmentType] Filter by commitment type  Deprecated: Use commitment types instead
         * @param {Array<CommitmentsAPIGetUsageSummaryCommitmentTypesEnum>} [commitmentTypes] Filter by commitment types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commitmentsAPIGetUsageSummary(organizationId: string, commitmentId: string, cloud?: CommitmentsAPIGetUsageSummaryCloudEnum, commitmentType?: CommitmentsAPIGetUsageSummaryCommitmentTypeEnum, commitmentTypes?: Array<CommitmentsAPIGetUsageSummaryCommitmentTypesEnum>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsageSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commitmentsAPIGetUsageSummary(organizationId, commitmentId, cloud, commitmentType, commitmentTypes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommitmentsAPIApi.commitmentsAPIGetUsageSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Import Azure commitments (reservations)
         * @param {string} organizationId Organization ID
         * @param {object} body 
         * @param {CommitmentsAPIImportAzureReservationsModeEnum} [mode] Behaviour
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commitmentsAPIImportAzureReservations(organizationId: string, body: object, mode?: CommitmentsAPIImportAzureReservationsModeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commitmentsAPIImportAzureReservations(organizationId, body, mode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommitmentsAPIApi.commitmentsAPIImportAzureReservations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List commitment assignments with pagination support.  This endpoint follows AIP standards and supports pagination with a maximum of 10,000 items per page.
         * @summary List commitment assignments.
         * @param {string} organizationId Organization ID
         * @param {string} commitmentId Optional commitment ID to filter assignments by  Accepts: empty (gRPC), \&quot;-\&quot; (wildcard for REST API, treated as empty), or valid UUID
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commitmentsAPIListCommitmentAssignments(organizationId: string, commitmentId: string, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCommitmentAssignmentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commitmentsAPIListCommitmentAssignments(organizationId, commitmentId, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommitmentsAPIApi.commitmentsAPIListCommitmentAssignments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List commitments with pagination, filtering, and sorting support.  Supersedes GetCommitments from the inventory API.
         * @summary List commitments.
         * @param {string} organizationId Organization ID
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {string} [sortField] The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
         * @param {CommitmentsAPIListCommitmentsSortOrderEnum} [sortOrder] The order of returned items. Default is ASC.
         * @param {Array<CommitmentsAPIListCommitmentsTypesEnum>} [types] Filter by commitment types
         * @param {Array<CommitmentsAPIListCommitmentsCloudsEnum>} [clouds] Filter by cloud providers
         * @param {string} [name] Filter by commitment name (case-insensitive, partial matching)
         * @param {Array<string>} [regions] Filter by regions
         * @param {string} [clusterId] Filter to commitments assigned to a specific cluster
         * @param {Array<CommitmentsAPIListCommitmentsStatesEnum>} [states] Filter by lifecycle states
         * @param {boolean} [includeTotalCount] Include total count of matching commitments in the response
         * @param {boolean} [unassigned] Filter to commitments that have no clusters assigned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commitmentsAPIListCommitments(organizationId: string, pageLimit?: string, pageCursor?: string, sortField?: string, sortOrder?: CommitmentsAPIListCommitmentsSortOrderEnum, types?: Array<CommitmentsAPIListCommitmentsTypesEnum>, clouds?: Array<CommitmentsAPIListCommitmentsCloudsEnum>, name?: string, regions?: Array<string>, clusterId?: string, states?: Array<CommitmentsAPIListCommitmentsStatesEnum>, includeTotalCount?: boolean, unassigned?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCommitmentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commitmentsAPIListCommitments(organizationId, pageLimit, pageCursor, sortField, sortOrder, types, clouds, name, regions, clusterId, states, includeTotalCount, unassigned, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommitmentsAPIApi.commitmentsAPIListCommitments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update mutable settings of an existing commitment.  Only operational settings (e.g. allowed usage, scaling strategy) are mutable via this method.
         * @summary Update a commitment.
         * @param {string} organizationId Organization ID
         * @param {string} id ID of the commitment to update
         * @param {UpdateCommitmentInput} updateCommitmentInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commitmentsAPIUpdateCommitment(organizationId: string, id: string, updateCommitmentInput: UpdateCommitmentInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Commitment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commitmentsAPIUpdateCommitment(organizationId, id, updateCommitmentInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommitmentsAPIApi.commitmentsAPIUpdateCommitment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CommitmentsAPIApi - factory interface
 * @export
 */
export const CommitmentsAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommitmentsAPIApiFp(configuration)
    return {
        /**
         * Batch create commitments. A maximum of 1000 commitments can be created in a single batch.  The operation is atomic: all commitments are created or none are.
         * @summary Batch create commitments.
         * @param {CommitmentsAPIApiCommitmentsAPIBatchCreateCommitmentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitmentsAPIBatchCreateCommitments(requestParameters: CommitmentsAPIApiCommitmentsAPIBatchCreateCommitmentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<BatchCreateCommitmentsResponse> {
            return localVarFp.commitmentsAPIBatchCreateCommitments(requestParameters.organizationId, requestParameters.batchCreateCommitmentsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Batch delete commitments. A maximum of 1000 commitments can be deleted in a single batch.  The operation is atomic: all commitments are deleted or none are.
         * @summary Batch delete commitments.
         * @param {CommitmentsAPIApiCommitmentsAPIBatchDeleteCommitmentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitmentsAPIBatchDeleteCommitments(requestParameters: CommitmentsAPIApiCommitmentsAPIBatchDeleteCommitmentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.commitmentsAPIBatchDeleteCommitments(requestParameters.organizationId, requestParameters.batchDeleteCommitmentsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Batch get usage breakdowns for multiple commitments.  Intended for table views where per-commitment usage data is needed for each row.  Returns breakdowns in the same order as the requested ids.
         * @summary Batch get commitment usage breakdowns.
         * @param {CommitmentsAPIApiCommitmentsAPIBatchGetCommitmentUsageBreakdownsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitmentsAPIBatchGetCommitmentUsageBreakdowns(requestParameters: CommitmentsAPIApiCommitmentsAPIBatchGetCommitmentUsageBreakdownsRequest, options?: RawAxiosRequestConfig): AxiosPromise<BatchGetCommitmentUsageBreakdownsResponse> {
            return localVarFp.commitmentsAPIBatchGetCommitmentUsageBreakdowns(requestParameters.organizationId, requestParameters.ids, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new commitment
         * @summary Create a commitment.
         * @param {CommitmentsAPIApiCommitmentsAPICreateCommitmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitmentsAPICreateCommitment(requestParameters: CommitmentsAPIApiCommitmentsAPICreateCommitmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<Commitment> {
            return localVarFp.commitmentsAPICreateCommitment(requestParameters.organizationId, requestParameters.createCommitmentInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a commitment by ID.
         * @summary Delete a commitment.
         * @param {CommitmentsAPIApiCommitmentsAPIDeleteCommitmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitmentsAPIDeleteCommitment(requestParameters: CommitmentsAPIApiCommitmentsAPIDeleteCommitmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.commitmentsAPIDeleteCommitment(requestParameters.organizationId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Azure commitments (reservations) import command
         * @param {CommitmentsAPIApiCommitmentsAPIGetAzureReservationsImportCommandRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitmentsAPIGetAzureReservationsImportCommand(requestParameters: CommitmentsAPIApiCommitmentsAPIGetAzureReservationsImportCommandRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAzureReservationsImportCommandResponse> {
            return localVarFp.commitmentsAPIGetAzureReservationsImportCommand(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a Azure commitments (reservations) import script
         * @param {CommitmentsAPIApiCommitmentsAPIGetAzureReservationsImportScriptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitmentsAPIGetAzureReservationsImportScript(requestParameters: CommitmentsAPIApiCommitmentsAPIGetAzureReservationsImportScriptRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.commitmentsAPIGetAzureReservationsImportScript(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single commitment by ID.
         * @summary Get a commitment.
         * @param {CommitmentsAPIApiCommitmentsAPIGetCommitmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitmentsAPIGetCommitment(requestParameters: CommitmentsAPIApiCommitmentsAPIGetCommitmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<Commitment> {
            return localVarFp.commitmentsAPIGetCommitment(requestParameters.organizationId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * (-- api-linter: core::0131::response-message-name=disabled      aip.dev/not-precedent: Custom method returning a custom response type. --)  Get clusters that have assignments for all of the given commitments in the  requested CSP.  At least one commitment_id is required; up to 100 per request.
         * @summary Get clusters assigned to the given commitments.
         * @param {CommitmentsAPIApiCommitmentsAPIGetCommitmentAssignedClustersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitmentsAPIGetCommitmentAssignedClusters(requestParameters: CommitmentsAPIApiCommitmentsAPIGetCommitmentAssignedClustersRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCommitmentAssignedClustersResponse> {
            return localVarFp.commitmentsAPIGetCommitmentAssignedClusters(requestParameters.organizationId, requestParameters.commitmentIds, requestParameters.cloud, options).then((request) => request(axios, basePath));
        },
        /**
         * Get usage breakdown for a single commitment.  Returns per-instance-type and per-cluster usage data.  For fetching breakdowns for multiple commitments (e.g. a table view), use BatchGetCommitmentUsageBreakdowns.
         * @summary Get commitment usage breakdown.
         * @param {CommitmentsAPIApiCommitmentsAPIGetCommitmentUsageBreakdownRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitmentsAPIGetCommitmentUsageBreakdown(requestParameters: CommitmentsAPIApiCommitmentsAPIGetCommitmentUsageBreakdownRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommitmentUsageBreakdown> {
            return localVarFp.commitmentsAPIGetCommitmentUsageBreakdown(requestParameters.organizationId, requestParameters.commitmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get commitment usage summary split by Cast-managed and other clusters
         * @param {CommitmentsAPIApiCommitmentsAPIGetUsageSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitmentsAPIGetUsageSummary(requestParameters: CommitmentsAPIApiCommitmentsAPIGetUsageSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<UsageSummary> {
            return localVarFp.commitmentsAPIGetUsageSummary(requestParameters.organizationId, requestParameters.commitmentId, requestParameters.cloud, requestParameters.commitmentType, requestParameters.commitmentTypes, options).then((request) => request(axios, basePath));
        },
        /**
         * Import Azure commitments (reservations)
         * @param {CommitmentsAPIApiCommitmentsAPIImportAzureReservationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitmentsAPIImportAzureReservations(requestParameters: CommitmentsAPIApiCommitmentsAPIImportAzureReservationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.commitmentsAPIImportAzureReservations(requestParameters.organizationId, requestParameters.body, requestParameters.mode, options).then((request) => request(axios, basePath));
        },
        /**
         * List commitment assignments with pagination support.  This endpoint follows AIP standards and supports pagination with a maximum of 10,000 items per page.
         * @summary List commitment assignments.
         * @param {CommitmentsAPIApiCommitmentsAPIListCommitmentAssignmentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitmentsAPIListCommitmentAssignments(requestParameters: CommitmentsAPIApiCommitmentsAPIListCommitmentAssignmentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListCommitmentAssignmentsResponse> {
            return localVarFp.commitmentsAPIListCommitmentAssignments(requestParameters.organizationId, requestParameters.commitmentId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
        /**
         * List commitments with pagination, filtering, and sorting support.  Supersedes GetCommitments from the inventory API.
         * @summary List commitments.
         * @param {CommitmentsAPIApiCommitmentsAPIListCommitmentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitmentsAPIListCommitments(requestParameters: CommitmentsAPIApiCommitmentsAPIListCommitmentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListCommitmentsResponse> {
            return localVarFp.commitmentsAPIListCommitments(requestParameters.organizationId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.sortField, requestParameters.sortOrder, requestParameters.types, requestParameters.clouds, requestParameters.name, requestParameters.regions, requestParameters.clusterId, requestParameters.states, requestParameters.includeTotalCount, requestParameters.unassigned, options).then((request) => request(axios, basePath));
        },
        /**
         * Update mutable settings of an existing commitment.  Only operational settings (e.g. allowed usage, scaling strategy) are mutable via this method.
         * @summary Update a commitment.
         * @param {CommitmentsAPIApiCommitmentsAPIUpdateCommitmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitmentsAPIUpdateCommitment(requestParameters: CommitmentsAPIApiCommitmentsAPIUpdateCommitmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<Commitment> {
            return localVarFp.commitmentsAPIUpdateCommitment(requestParameters.organizationId, requestParameters.id, requestParameters.updateCommitmentInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for commitmentsAPIBatchCreateCommitments operation in CommitmentsAPIApi.
 * @export
 * @interface CommitmentsAPIApiCommitmentsAPIBatchCreateCommitmentsRequest
 */
export interface CommitmentsAPIApiCommitmentsAPIBatchCreateCommitmentsRequest {
    /**
     * Organization ID shared by all commitments
     * @type {string}
     * @memberof CommitmentsAPIApiCommitmentsAPIBatchCreateCommitments
     */
    readonly organizationId: string

    /**
     * 
     * @type {BatchCreateCommitmentsRequest}
     * @memberof CommitmentsAPIApiCommitmentsAPIBatchCreateCommitments
     */
    readonly batchCreateCommitmentsRequest: BatchCreateCommitmentsRequest
}

/**
 * Request parameters for commitmentsAPIBatchDeleteCommitments operation in CommitmentsAPIApi.
 * @export
 * @interface CommitmentsAPIApiCommitmentsAPIBatchDeleteCommitmentsRequest
 */
export interface CommitmentsAPIApiCommitmentsAPIBatchDeleteCommitmentsRequest {
    /**
     * Organization ID shared by all commitments
     * @type {string}
     * @memberof CommitmentsAPIApiCommitmentsAPIBatchDeleteCommitments
     */
    readonly organizationId: string

    /**
     * 
     * @type {BatchDeleteCommitmentsRequest}
     * @memberof CommitmentsAPIApiCommitmentsAPIBatchDeleteCommitments
     */
    readonly batchDeleteCommitmentsRequest: BatchDeleteCommitmentsRequest
}

/**
 * Request parameters for commitmentsAPIBatchGetCommitmentUsageBreakdowns operation in CommitmentsAPIApi.
 * @export
 * @interface CommitmentsAPIApiCommitmentsAPIBatchGetCommitmentUsageBreakdownsRequest
 */
export interface CommitmentsAPIApiCommitmentsAPIBatchGetCommitmentUsageBreakdownsRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof CommitmentsAPIApiCommitmentsAPIBatchGetCommitmentUsageBreakdowns
     */
    readonly organizationId: string

    /**
     * Commitment IDs to fetch breakdowns for. A maximum of 1000 commitments can be retrieved in a batch.
     * @type {Array<string>}
     * @memberof CommitmentsAPIApiCommitmentsAPIBatchGetCommitmentUsageBreakdowns
     */
    readonly ids?: Array<string>
}

/**
 * Request parameters for commitmentsAPICreateCommitment operation in CommitmentsAPIApi.
 * @export
 * @interface CommitmentsAPIApiCommitmentsAPICreateCommitmentRequest
 */
export interface CommitmentsAPIApiCommitmentsAPICreateCommitmentRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof CommitmentsAPIApiCommitmentsAPICreateCommitment
     */
    readonly organizationId: string

    /**
     * 
     * @type {CreateCommitmentInput}
     * @memberof CommitmentsAPIApiCommitmentsAPICreateCommitment
     */
    readonly createCommitmentInput: CreateCommitmentInput
}

/**
 * Request parameters for commitmentsAPIDeleteCommitment operation in CommitmentsAPIApi.
 * @export
 * @interface CommitmentsAPIApiCommitmentsAPIDeleteCommitmentRequest
 */
export interface CommitmentsAPIApiCommitmentsAPIDeleteCommitmentRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof CommitmentsAPIApiCommitmentsAPIDeleteCommitment
     */
    readonly organizationId: string

    /**
     * ID of the commitment to delete
     * @type {string}
     * @memberof CommitmentsAPIApiCommitmentsAPIDeleteCommitment
     */
    readonly id: string
}

/**
 * Request parameters for commitmentsAPIGetAzureReservationsImportCommand operation in CommitmentsAPIApi.
 * @export
 * @interface CommitmentsAPIApiCommitmentsAPIGetAzureReservationsImportCommandRequest
 */
export interface CommitmentsAPIApiCommitmentsAPIGetAzureReservationsImportCommandRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof CommitmentsAPIApiCommitmentsAPIGetAzureReservationsImportCommand
     */
    readonly organizationId: string
}

/**
 * Request parameters for commitmentsAPIGetAzureReservationsImportScript operation in CommitmentsAPIApi.
 * @export
 * @interface CommitmentsAPIApiCommitmentsAPIGetAzureReservationsImportScriptRequest
 */
export interface CommitmentsAPIApiCommitmentsAPIGetAzureReservationsImportScriptRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof CommitmentsAPIApiCommitmentsAPIGetAzureReservationsImportScript
     */
    readonly organizationId: string
}

/**
 * Request parameters for commitmentsAPIGetCommitment operation in CommitmentsAPIApi.
 * @export
 * @interface CommitmentsAPIApiCommitmentsAPIGetCommitmentRequest
 */
export interface CommitmentsAPIApiCommitmentsAPIGetCommitmentRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof CommitmentsAPIApiCommitmentsAPIGetCommitment
     */
    readonly organizationId: string

    /**
     * ID of the commitment to retrieve
     * @type {string}
     * @memberof CommitmentsAPIApiCommitmentsAPIGetCommitment
     */
    readonly id: string
}

/**
 * Request parameters for commitmentsAPIGetCommitmentAssignedClusters operation in CommitmentsAPIApi.
 * @export
 * @interface CommitmentsAPIApiCommitmentsAPIGetCommitmentAssignedClustersRequest
 */
export interface CommitmentsAPIApiCommitmentsAPIGetCommitmentAssignedClustersRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof CommitmentsAPIApiCommitmentsAPIGetCommitmentAssignedClusters
     */
    readonly organizationId: string

    /**
     * Filter to clusters assigned to ALL of these commitment IDs.  A cluster is returned only if it has an assignment for every commitment_id  in this list.  Required: at least one commitment_id; at most 100.
     * @type {Array<string>}
     * @memberof CommitmentsAPIApiCommitmentsAPIGetCommitmentAssignedClusters
     */
    readonly commitmentIds?: Array<string>

    /**
     * Required: filter by cloud service provider.
     * @type {'CLOUD_UNSPECIFIED' | 'GCP' | 'AWS' | 'AZURE' | 'ORACLE' | 'NEBIUS'}
     * @memberof CommitmentsAPIApiCommitmentsAPIGetCommitmentAssignedClusters
     */
    readonly cloud?: CommitmentsAPIGetCommitmentAssignedClustersCloudEnum
}

/**
 * Request parameters for commitmentsAPIGetCommitmentUsageBreakdown operation in CommitmentsAPIApi.
 * @export
 * @interface CommitmentsAPIApiCommitmentsAPIGetCommitmentUsageBreakdownRequest
 */
export interface CommitmentsAPIApiCommitmentsAPIGetCommitmentUsageBreakdownRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof CommitmentsAPIApiCommitmentsAPIGetCommitmentUsageBreakdown
     */
    readonly organizationId: string

    /**
     * Commitment ID
     * @type {string}
     * @memberof CommitmentsAPIApiCommitmentsAPIGetCommitmentUsageBreakdown
     */
    readonly commitmentId: string
}

/**
 * Request parameters for commitmentsAPIGetUsageSummary operation in CommitmentsAPIApi.
 * @export
 * @interface CommitmentsAPIApiCommitmentsAPIGetUsageSummaryRequest
 */
export interface CommitmentsAPIApiCommitmentsAPIGetUsageSummaryRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof CommitmentsAPIApiCommitmentsAPIGetUsageSummary
     */
    readonly organizationId: string

    /**
     * Commitment ID to filter by. Use \&quot;-\&quot; for all commitments.
     * @type {string}
     * @memberof CommitmentsAPIApiCommitmentsAPIGetUsageSummary
     */
    readonly commitmentId: string

    /**
     * Filter by cloud provider
     * @type {'CLOUD_UNSPECIFIED' | 'GCP' | 'AWS' | 'AZURE' | 'ORACLE' | 'NEBIUS'}
     * @memberof CommitmentsAPIApiCommitmentsAPIGetUsageSummary
     */
    readonly cloud?: CommitmentsAPIGetUsageSummaryCloudEnum

    /**
     * Filter by commitment type  Deprecated: Use commitment types instead
     * @type {'COMMITMENT_TYPE_UNSPECIFIED' | 'RESERVED_INSTANCE' | 'RESOURCE_CUD' | 'SAVINGS_PLAN' | 'CAPACITY_BLOCK' | 'ON_DEMAND_CAPACITY_RESERVATION' | 'FLEX_CUD'}
     * @memberof CommitmentsAPIApiCommitmentsAPIGetUsageSummary
     */
    readonly commitmentType?: CommitmentsAPIGetUsageSummaryCommitmentTypeEnum

    /**
     * Filter by commitment types
     * @type {Array<'COMMITMENT_TYPE_UNSPECIFIED' | 'RESERVED_INSTANCE' | 'RESOURCE_CUD' | 'SAVINGS_PLAN' | 'CAPACITY_BLOCK' | 'ON_DEMAND_CAPACITY_RESERVATION' | 'FLEX_CUD'>}
     * @memberof CommitmentsAPIApiCommitmentsAPIGetUsageSummary
     */
    readonly commitmentTypes?: Array<CommitmentsAPIGetUsageSummaryCommitmentTypesEnum>
}

/**
 * Request parameters for commitmentsAPIImportAzureReservations operation in CommitmentsAPIApi.
 * @export
 * @interface CommitmentsAPIApiCommitmentsAPIImportAzureReservationsRequest
 */
export interface CommitmentsAPIApiCommitmentsAPIImportAzureReservationsRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof CommitmentsAPIApiCommitmentsAPIImportAzureReservations
     */
    readonly organizationId: string

    /**
     * 
     * @type {object}
     * @memberof CommitmentsAPIApiCommitmentsAPIImportAzureReservations
     */
    readonly body: object

    /**
     * Behaviour
     * @type {'MODE_UNSPECIFIED' | 'OVERWRITE' | 'APPEND'}
     * @memberof CommitmentsAPIApiCommitmentsAPIImportAzureReservations
     */
    readonly mode?: CommitmentsAPIImportAzureReservationsModeEnum
}

/**
 * Request parameters for commitmentsAPIListCommitmentAssignments operation in CommitmentsAPIApi.
 * @export
 * @interface CommitmentsAPIApiCommitmentsAPIListCommitmentAssignmentsRequest
 */
export interface CommitmentsAPIApiCommitmentsAPIListCommitmentAssignmentsRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof CommitmentsAPIApiCommitmentsAPIListCommitmentAssignments
     */
    readonly organizationId: string

    /**
     * Optional commitment ID to filter assignments by  Accepts: empty (gRPC), \&quot;-\&quot; (wildcard for REST API, treated as empty), or valid UUID
     * @type {string}
     * @memberof CommitmentsAPIApiCommitmentsAPIListCommitmentAssignments
     */
    readonly commitmentId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof CommitmentsAPIApiCommitmentsAPIListCommitmentAssignments
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof CommitmentsAPIApiCommitmentsAPIListCommitmentAssignments
     */
    readonly pageCursor?: string
}

/**
 * Request parameters for commitmentsAPIListCommitments operation in CommitmentsAPIApi.
 * @export
 * @interface CommitmentsAPIApiCommitmentsAPIListCommitmentsRequest
 */
export interface CommitmentsAPIApiCommitmentsAPIListCommitmentsRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof CommitmentsAPIApiCommitmentsAPIListCommitments
     */
    readonly organizationId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof CommitmentsAPIApiCommitmentsAPIListCommitments
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof CommitmentsAPIApiCommitmentsAPIListCommitments
     */
    readonly pageCursor?: string

    /**
     * The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
     * @type {string}
     * @memberof CommitmentsAPIApiCommitmentsAPIListCommitments
     */
    readonly sortField?: string

    /**
     * The order of returned items. Default is ASC.
     * @type {'ASC' | 'asc' | 'DESC' | 'desc'}
     * @memberof CommitmentsAPIApiCommitmentsAPIListCommitments
     */
    readonly sortOrder?: CommitmentsAPIListCommitmentsSortOrderEnum

    /**
     * Filter by commitment types
     * @type {Array<'COMMITMENT_TYPE_UNSPECIFIED' | 'RESERVED_INSTANCE' | 'RESOURCE_CUD' | 'SAVINGS_PLAN' | 'CAPACITY_BLOCK' | 'ON_DEMAND_CAPACITY_RESERVATION' | 'FLEX_CUD'>}
     * @memberof CommitmentsAPIApiCommitmentsAPIListCommitments
     */
    readonly types?: Array<CommitmentsAPIListCommitmentsTypesEnum>

    /**
     * Filter by cloud providers
     * @type {Array<'CLOUD_UNSPECIFIED' | 'GCP' | 'AWS' | 'AZURE' | 'ORACLE' | 'NEBIUS'>}
     * @memberof CommitmentsAPIApiCommitmentsAPIListCommitments
     */
    readonly clouds?: Array<CommitmentsAPIListCommitmentsCloudsEnum>

    /**
     * Filter by commitment name (case-insensitive, partial matching)
     * @type {string}
     * @memberof CommitmentsAPIApiCommitmentsAPIListCommitments
     */
    readonly name?: string

    /**
     * Filter by regions
     * @type {Array<string>}
     * @memberof CommitmentsAPIApiCommitmentsAPIListCommitments
     */
    readonly regions?: Array<string>

    /**
     * Filter to commitments assigned to a specific cluster
     * @type {string}
     * @memberof CommitmentsAPIApiCommitmentsAPIListCommitments
     */
    readonly clusterId?: string

    /**
     * Filter by lifecycle states
     * @type {Array<'STATE_UNSPECIFIED' | 'STATE_ACTIVE' | 'STATE_PENDING' | 'STATE_EXPIRED' | 'STATE_DELETED' | 'STATE_INACTIVE'>}
     * @memberof CommitmentsAPIApiCommitmentsAPIListCommitments
     */
    readonly states?: Array<CommitmentsAPIListCommitmentsStatesEnum>

    /**
     * Include total count of matching commitments in the response
     * @type {boolean}
     * @memberof CommitmentsAPIApiCommitmentsAPIListCommitments
     */
    readonly includeTotalCount?: boolean

    /**
     * Filter to commitments that have no clusters assigned.
     * @type {boolean}
     * @memberof CommitmentsAPIApiCommitmentsAPIListCommitments
     */
    readonly unassigned?: boolean
}

/**
 * Request parameters for commitmentsAPIUpdateCommitment operation in CommitmentsAPIApi.
 * @export
 * @interface CommitmentsAPIApiCommitmentsAPIUpdateCommitmentRequest
 */
export interface CommitmentsAPIApiCommitmentsAPIUpdateCommitmentRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof CommitmentsAPIApiCommitmentsAPIUpdateCommitment
     */
    readonly organizationId: string

    /**
     * ID of the commitment to update
     * @type {string}
     * @memberof CommitmentsAPIApiCommitmentsAPIUpdateCommitment
     */
    readonly id: string

    /**
     * 
     * @type {UpdateCommitmentInput}
     * @memberof CommitmentsAPIApiCommitmentsAPIUpdateCommitment
     */
    readonly updateCommitmentInput: UpdateCommitmentInput
}

/**
 * CommitmentsAPIApi - object-oriented interface
 * @export
 * @class CommitmentsAPIApi
 * @extends {BaseAPI}
 */
export class CommitmentsAPIApi extends BaseAPI {
    /**
     * Batch create commitments. A maximum of 1000 commitments can be created in a single batch.  The operation is atomic: all commitments are created or none are.
     * @summary Batch create commitments.
     * @param {CommitmentsAPIApiCommitmentsAPIBatchCreateCommitmentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitmentsAPIApi
     */
    public commitmentsAPIBatchCreateCommitments(requestParameters: CommitmentsAPIApiCommitmentsAPIBatchCreateCommitmentsRequest, options?: RawAxiosRequestConfig) {
        return CommitmentsAPIApiFp(this.configuration).commitmentsAPIBatchCreateCommitments(requestParameters.organizationId, requestParameters.batchCreateCommitmentsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Batch delete commitments. A maximum of 1000 commitments can be deleted in a single batch.  The operation is atomic: all commitments are deleted or none are.
     * @summary Batch delete commitments.
     * @param {CommitmentsAPIApiCommitmentsAPIBatchDeleteCommitmentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitmentsAPIApi
     */
    public commitmentsAPIBatchDeleteCommitments(requestParameters: CommitmentsAPIApiCommitmentsAPIBatchDeleteCommitmentsRequest, options?: RawAxiosRequestConfig) {
        return CommitmentsAPIApiFp(this.configuration).commitmentsAPIBatchDeleteCommitments(requestParameters.organizationId, requestParameters.batchDeleteCommitmentsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Batch get usage breakdowns for multiple commitments.  Intended for table views where per-commitment usage data is needed for each row.  Returns breakdowns in the same order as the requested ids.
     * @summary Batch get commitment usage breakdowns.
     * @param {CommitmentsAPIApiCommitmentsAPIBatchGetCommitmentUsageBreakdownsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitmentsAPIApi
     */
    public commitmentsAPIBatchGetCommitmentUsageBreakdowns(requestParameters: CommitmentsAPIApiCommitmentsAPIBatchGetCommitmentUsageBreakdownsRequest, options?: RawAxiosRequestConfig) {
        return CommitmentsAPIApiFp(this.configuration).commitmentsAPIBatchGetCommitmentUsageBreakdowns(requestParameters.organizationId, requestParameters.ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new commitment
     * @summary Create a commitment.
     * @param {CommitmentsAPIApiCommitmentsAPICreateCommitmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitmentsAPIApi
     */
    public commitmentsAPICreateCommitment(requestParameters: CommitmentsAPIApiCommitmentsAPICreateCommitmentRequest, options?: RawAxiosRequestConfig) {
        return CommitmentsAPIApiFp(this.configuration).commitmentsAPICreateCommitment(requestParameters.organizationId, requestParameters.createCommitmentInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a commitment by ID.
     * @summary Delete a commitment.
     * @param {CommitmentsAPIApiCommitmentsAPIDeleteCommitmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitmentsAPIApi
     */
    public commitmentsAPIDeleteCommitment(requestParameters: CommitmentsAPIApiCommitmentsAPIDeleteCommitmentRequest, options?: RawAxiosRequestConfig) {
        return CommitmentsAPIApiFp(this.configuration).commitmentsAPIDeleteCommitment(requestParameters.organizationId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Azure commitments (reservations) import command
     * @param {CommitmentsAPIApiCommitmentsAPIGetAzureReservationsImportCommandRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitmentsAPIApi
     */
    public commitmentsAPIGetAzureReservationsImportCommand(requestParameters: CommitmentsAPIApiCommitmentsAPIGetAzureReservationsImportCommandRequest, options?: RawAxiosRequestConfig) {
        return CommitmentsAPIApiFp(this.configuration).commitmentsAPIGetAzureReservationsImportCommand(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a Azure commitments (reservations) import script
     * @param {CommitmentsAPIApiCommitmentsAPIGetAzureReservationsImportScriptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitmentsAPIApi
     */
    public commitmentsAPIGetAzureReservationsImportScript(requestParameters: CommitmentsAPIApiCommitmentsAPIGetAzureReservationsImportScriptRequest, options?: RawAxiosRequestConfig) {
        return CommitmentsAPIApiFp(this.configuration).commitmentsAPIGetAzureReservationsImportScript(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single commitment by ID.
     * @summary Get a commitment.
     * @param {CommitmentsAPIApiCommitmentsAPIGetCommitmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitmentsAPIApi
     */
    public commitmentsAPIGetCommitment(requestParameters: CommitmentsAPIApiCommitmentsAPIGetCommitmentRequest, options?: RawAxiosRequestConfig) {
        return CommitmentsAPIApiFp(this.configuration).commitmentsAPIGetCommitment(requestParameters.organizationId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * (-- api-linter: core::0131::response-message-name=disabled      aip.dev/not-precedent: Custom method returning a custom response type. --)  Get clusters that have assignments for all of the given commitments in the  requested CSP.  At least one commitment_id is required; up to 100 per request.
     * @summary Get clusters assigned to the given commitments.
     * @param {CommitmentsAPIApiCommitmentsAPIGetCommitmentAssignedClustersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitmentsAPIApi
     */
    public commitmentsAPIGetCommitmentAssignedClusters(requestParameters: CommitmentsAPIApiCommitmentsAPIGetCommitmentAssignedClustersRequest, options?: RawAxiosRequestConfig) {
        return CommitmentsAPIApiFp(this.configuration).commitmentsAPIGetCommitmentAssignedClusters(requestParameters.organizationId, requestParameters.commitmentIds, requestParameters.cloud, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get usage breakdown for a single commitment.  Returns per-instance-type and per-cluster usage data.  For fetching breakdowns for multiple commitments (e.g. a table view), use BatchGetCommitmentUsageBreakdowns.
     * @summary Get commitment usage breakdown.
     * @param {CommitmentsAPIApiCommitmentsAPIGetCommitmentUsageBreakdownRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitmentsAPIApi
     */
    public commitmentsAPIGetCommitmentUsageBreakdown(requestParameters: CommitmentsAPIApiCommitmentsAPIGetCommitmentUsageBreakdownRequest, options?: RawAxiosRequestConfig) {
        return CommitmentsAPIApiFp(this.configuration).commitmentsAPIGetCommitmentUsageBreakdown(requestParameters.organizationId, requestParameters.commitmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get commitment usage summary split by Cast-managed and other clusters
     * @param {CommitmentsAPIApiCommitmentsAPIGetUsageSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitmentsAPIApi
     */
    public commitmentsAPIGetUsageSummary(requestParameters: CommitmentsAPIApiCommitmentsAPIGetUsageSummaryRequest, options?: RawAxiosRequestConfig) {
        return CommitmentsAPIApiFp(this.configuration).commitmentsAPIGetUsageSummary(requestParameters.organizationId, requestParameters.commitmentId, requestParameters.cloud, requestParameters.commitmentType, requestParameters.commitmentTypes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Import Azure commitments (reservations)
     * @param {CommitmentsAPIApiCommitmentsAPIImportAzureReservationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitmentsAPIApi
     */
    public commitmentsAPIImportAzureReservations(requestParameters: CommitmentsAPIApiCommitmentsAPIImportAzureReservationsRequest, options?: RawAxiosRequestConfig) {
        return CommitmentsAPIApiFp(this.configuration).commitmentsAPIImportAzureReservations(requestParameters.organizationId, requestParameters.body, requestParameters.mode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List commitment assignments with pagination support.  This endpoint follows AIP standards and supports pagination with a maximum of 10,000 items per page.
     * @summary List commitment assignments.
     * @param {CommitmentsAPIApiCommitmentsAPIListCommitmentAssignmentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitmentsAPIApi
     */
    public commitmentsAPIListCommitmentAssignments(requestParameters: CommitmentsAPIApiCommitmentsAPIListCommitmentAssignmentsRequest, options?: RawAxiosRequestConfig) {
        return CommitmentsAPIApiFp(this.configuration).commitmentsAPIListCommitmentAssignments(requestParameters.organizationId, requestParameters.commitmentId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List commitments with pagination, filtering, and sorting support.  Supersedes GetCommitments from the inventory API.
     * @summary List commitments.
     * @param {CommitmentsAPIApiCommitmentsAPIListCommitmentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitmentsAPIApi
     */
    public commitmentsAPIListCommitments(requestParameters: CommitmentsAPIApiCommitmentsAPIListCommitmentsRequest, options?: RawAxiosRequestConfig) {
        return CommitmentsAPIApiFp(this.configuration).commitmentsAPIListCommitments(requestParameters.organizationId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.sortField, requestParameters.sortOrder, requestParameters.types, requestParameters.clouds, requestParameters.name, requestParameters.regions, requestParameters.clusterId, requestParameters.states, requestParameters.includeTotalCount, requestParameters.unassigned, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update mutable settings of an existing commitment.  Only operational settings (e.g. allowed usage, scaling strategy) are mutable via this method.
     * @summary Update a commitment.
     * @param {CommitmentsAPIApiCommitmentsAPIUpdateCommitmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitmentsAPIApi
     */
    public commitmentsAPIUpdateCommitment(requestParameters: CommitmentsAPIApiCommitmentsAPIUpdateCommitmentRequest, options?: RawAxiosRequestConfig) {
        return CommitmentsAPIApiFp(this.configuration).commitmentsAPIUpdateCommitment(requestParameters.organizationId, requestParameters.id, requestParameters.updateCommitmentInput, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const CommitmentsAPIGetCommitmentAssignedClustersCloudEnum = {
    CLOUD_UNSPECIFIED: 'CLOUD_UNSPECIFIED',
    GCP: 'GCP',
    AWS: 'AWS',
    AZURE: 'AZURE',
    ORACLE: 'ORACLE',
    NEBIUS: 'NEBIUS'
} as const;
export type CommitmentsAPIGetCommitmentAssignedClustersCloudEnum = typeof CommitmentsAPIGetCommitmentAssignedClustersCloudEnum[keyof typeof CommitmentsAPIGetCommitmentAssignedClustersCloudEnum];
/**
 * @export
 */
export const CommitmentsAPIGetUsageSummaryCloudEnum = {
    CLOUD_UNSPECIFIED: 'CLOUD_UNSPECIFIED',
    GCP: 'GCP',
    AWS: 'AWS',
    AZURE: 'AZURE',
    ORACLE: 'ORACLE',
    NEBIUS: 'NEBIUS'
} as const;
export type CommitmentsAPIGetUsageSummaryCloudEnum = typeof CommitmentsAPIGetUsageSummaryCloudEnum[keyof typeof CommitmentsAPIGetUsageSummaryCloudEnum];
/**
 * @export
 */
export const CommitmentsAPIGetUsageSummaryCommitmentTypeEnum = {
    COMMITMENT_TYPE_UNSPECIFIED: 'COMMITMENT_TYPE_UNSPECIFIED',
    RESERVED_INSTANCE: 'RESERVED_INSTANCE',
    RESOURCE_CUD: 'RESOURCE_CUD',
    SAVINGS_PLAN: 'SAVINGS_PLAN',
    CAPACITY_BLOCK: 'CAPACITY_BLOCK',
    ON_DEMAND_CAPACITY_RESERVATION: 'ON_DEMAND_CAPACITY_RESERVATION',
    FLEX_CUD: 'FLEX_CUD'
} as const;
export type CommitmentsAPIGetUsageSummaryCommitmentTypeEnum = typeof CommitmentsAPIGetUsageSummaryCommitmentTypeEnum[keyof typeof CommitmentsAPIGetUsageSummaryCommitmentTypeEnum];
/**
 * @export
 */
export const CommitmentsAPIGetUsageSummaryCommitmentTypesEnum = {
    COMMITMENT_TYPE_UNSPECIFIED: 'COMMITMENT_TYPE_UNSPECIFIED',
    RESERVED_INSTANCE: 'RESERVED_INSTANCE',
    RESOURCE_CUD: 'RESOURCE_CUD',
    SAVINGS_PLAN: 'SAVINGS_PLAN',
    CAPACITY_BLOCK: 'CAPACITY_BLOCK',
    ON_DEMAND_CAPACITY_RESERVATION: 'ON_DEMAND_CAPACITY_RESERVATION',
    FLEX_CUD: 'FLEX_CUD'
} as const;
export type CommitmentsAPIGetUsageSummaryCommitmentTypesEnum = typeof CommitmentsAPIGetUsageSummaryCommitmentTypesEnum[keyof typeof CommitmentsAPIGetUsageSummaryCommitmentTypesEnum];
/**
 * @export
 */
export const CommitmentsAPIImportAzureReservationsModeEnum = {
    MODE_UNSPECIFIED: 'MODE_UNSPECIFIED',
    OVERWRITE: 'OVERWRITE',
    APPEND: 'APPEND'
} as const;
export type CommitmentsAPIImportAzureReservationsModeEnum = typeof CommitmentsAPIImportAzureReservationsModeEnum[keyof typeof CommitmentsAPIImportAzureReservationsModeEnum];
/**
 * @export
 */
export const CommitmentsAPIListCommitmentsSortOrderEnum = {
    ASC: 'ASC',
    asc: 'asc',
    DESC: 'DESC',
    desc: 'desc'
} as const;
export type CommitmentsAPIListCommitmentsSortOrderEnum = typeof CommitmentsAPIListCommitmentsSortOrderEnum[keyof typeof CommitmentsAPIListCommitmentsSortOrderEnum];
/**
 * @export
 */
export const CommitmentsAPIListCommitmentsTypesEnum = {
    COMMITMENT_TYPE_UNSPECIFIED: 'COMMITMENT_TYPE_UNSPECIFIED',
    RESERVED_INSTANCE: 'RESERVED_INSTANCE',
    RESOURCE_CUD: 'RESOURCE_CUD',
    SAVINGS_PLAN: 'SAVINGS_PLAN',
    CAPACITY_BLOCK: 'CAPACITY_BLOCK',
    ON_DEMAND_CAPACITY_RESERVATION: 'ON_DEMAND_CAPACITY_RESERVATION',
    FLEX_CUD: 'FLEX_CUD'
} as const;
export type CommitmentsAPIListCommitmentsTypesEnum = typeof CommitmentsAPIListCommitmentsTypesEnum[keyof typeof CommitmentsAPIListCommitmentsTypesEnum];
/**
 * @export
 */
export const CommitmentsAPIListCommitmentsCloudsEnum = {
    CLOUD_UNSPECIFIED: 'CLOUD_UNSPECIFIED',
    GCP: 'GCP',
    AWS: 'AWS',
    AZURE: 'AZURE',
    ORACLE: 'ORACLE',
    NEBIUS: 'NEBIUS'
} as const;
export type CommitmentsAPIListCommitmentsCloudsEnum = typeof CommitmentsAPIListCommitmentsCloudsEnum[keyof typeof CommitmentsAPIListCommitmentsCloudsEnum];
/**
 * @export
 */
export const CommitmentsAPIListCommitmentsStatesEnum = {
    UNSPECIFIED: 'STATE_UNSPECIFIED',
    ACTIVE: 'STATE_ACTIVE',
    PENDING: 'STATE_PENDING',
    EXPIRED: 'STATE_EXPIRED',
    DELETED: 'STATE_DELETED',
    INACTIVE: 'STATE_INACTIVE'
} as const;
export type CommitmentsAPIListCommitmentsStatesEnum = typeof CommitmentsAPIListCommitmentsStatesEnum[keyof typeof CommitmentsAPIListCommitmentsStatesEnum];
